import { useSearchParams } from 'react-router';
import { ErrorState, Loading, useTitle } from '../../ui/bits';
import { ProductList } from '../../catalog/ProductList';
import { LINES } from '../../catalog/lib/list.js';
import { useOpsShops } from '../queries';

/** /ops/products — every shop's products, with a shop filter; editing uses the shared editor. */
export function OpsProductsPage() {
  useTitle('Products');
  const shops = useOpsShops();
  const [params] = useSearchParams();
  if (shops.isError)
    return (
      <section className="card">
        <ErrorState error={shops.error} onRetry={() => void shops.refetch()} />
      </section>
    );
  if (!shops.data) return <Loading label="Loading shops" rows={3} />;
  const list = shops.data.slice().sort((a, b) => a.name.localeCompare(b.name));
  const shopId = params.get('shop') || '';
  const shop = list.find((s) => s.id === shopId);
  return (
    <ProductList
      scope="ops"
      lines={shop ? shop.lines : [...LINES]}
      shops={list}
      editPath={(p) => `/ops/products/${encodeURIComponent(list.find((s) => s.id === p.shopId)?.slug || p.shopId)}/${encodeURIComponent(p.id)}`}
      newPath={shop ? `/ops/products/new?shop=${encodeURIComponent(shop.id)}` : '/ops/products/new'}
      heading="Products"
      sub={shop ? `${shop.name} · acting as PopCart Ops` : 'All shops'}
    />
  );
}
